
          function barLoadMore(pageNumber,productsCount) {
            const pageNumberInProducts = document.querySelector('#page-number-in-products');
            const loadMoreHeaderChange = document.querySelector('#load-more-header-change');
            
            
            const sliderProductBox = document.querySelector('.in-box-silder-page');
            if((productsCount/48) <= 1){
              
              pageNumberInProducts.innerHTML = `נצפו ${productsCount} מתוך ${productsCount}`;
              loadMoreHeaderChange.innerHTML = `מציג ${productsCount} מתוך ${productsCount}`;
              loadmore.style = "display: none;";
              sliderProductBox.style = `width: 100%`
            }else{
              
              if((48*parseInt(pageNumber)) < productsCount){
                // pageNumberInProducts.innerHTML = productsCount  + '/' + (48*parseInt(pageNumber));
                pageNumberInProducts.innerHTML =  `נצפו ${(48*parseInt(pageNumber))} מתוך ${productsCount}`;
                loadMoreHeaderChange.innerHTML =  `מציג ${(48*parseInt(pageNumber))} מתוך ${productsCount}`;
                loadmore.classList.add("button-loadding-prodcuts");
                loadmore.innerHTML = `טען עוד`;
                const pageNumberInProductsInPresents = ((48*parseInt(pageNumber))/productsCount) * 100;
                sliderProductBox.style = `width: ${pageNumberInProductsInPresents}%`
              }else{
                pageNumberInProducts.innerHTML =  `נצפו ${productsCount} מתוך ${productsCount}`;
                loadMoreHeaderChange.innerHTML =  `מציג ${productsCount} מתוך ${productsCount}`;
                
                sliderProductBox.style = `width: 100%`
                loadmore.style = "display: none;";
                
              }
            }
          }
           function barLoadBefore(pageNumber,lastPageNumberLoadBeforeClick) {
            const pageNumberInProducts = document.querySelector('#page-number-in-products');
            const loadMoreHeaderChange = document.querySelector('#load-more-header-change');
            
            if(pageNumber >= 1 && lastPageNumberLoadBeforeClick >= 1){
              // loadbefore.
            }
          }

          
          function getBeforePage(type) {
                var currentUrl = window.location.href;
                var parsedUrl = new URL(currentUrl);
                parsedUrl.hash = '';
                  var urlParams = new URLSearchParams(parsedUrl.search);
                if (urlParams.has('page')) {
                  var pageNumber = urlParams.get('page');            
                  if(type == "static"){
                      var pageNumber = urlParams.get('page');
                      if(parseInt(pageNumber) > 1){
                        loadbefore.setAttribute("data-before-pagenumber", parseInt(pageNumber)-1);
                        loadbefore.style.display = "block"

                      }else{
                        return 1;
                      }
                    
                  }else if(type == "click"){
                    
                     const lastPageBeforeNumber = loadbefore.getAttribute("data-before-pagenumber");
                     if(lastPageBeforeNumber >= 1){
                        const lastPageBeforeNumberLes = parseInt(lastPageBeforeNumber)-1
                        loadbefore.setAttribute("data-before-pagenumber", lastPageBeforeNumberLes);
                        var params = parsedUrl.searchParams;
                        params.set('page', lastPageBeforeNumber);
                        var lastPageUrlPage = parsedUrl.toString();
                       
                       
                        return lastPageUrlPage;
                       
                      }else{
                        loadbefore.style.display = "none"
                      }
                  
                  }
                }else{
                  loadbefore.style.display = "none"
                }
        }
        function getNextPage() {
            
            const productsCount = loadmore.getAttribute("data-products-count");
            var currentUrl = window.location.href;
            var parsedUrl = new URL(currentUrl);
            parsedUrl.hash = ''; // rm hash #
            // console.log(parsedUrl);
            // console.log(productsCount);
            if(productsCount <= 48){
              // barLoadMore()
              barLoadMore(0,productsCount);
              return false;
            }else{
              if(loadmore.getAttribute("data-next-link") == "first_load"){
                
                var urlParams = new URLSearchParams(parsedUrl.search);
              
                if (urlParams.has('page')) {
                    var pageNumber = urlParams.get('page');
                    barLoadMore(pageNumber,productsCount);
                    // console.log('Page number:', pageNumber);
                    var nextPage = parseInt(pageNumber) + 1;
                    var params = parsedUrl.searchParams;
                    params.set('page', nextPage);
                    var nextUrlPage = parsedUrl.toString();
                  
                } else {
                    var nextPage = 2;
                    var params = parsedUrl.searchParams;
                    params.set('page', nextPage);
                    var nextUrlPage = parsedUrl.toString();
                    barLoadMore(1,productsCount);
                }
                  
                
              }else{
                const elNextPage = loadmore.getAttribute("data-next-link");
                var nextUrlPage = elNextPage;
                
              }
              return nextUrlPage;
            }
            // const scrollPosition = localStorage.getItem("scrollPosition");
            //     if (scrollPosition) {
            //         window.scrollTo(0, scrollPosition);
            //     }
          }
        
         getNextPage();
           getBeforePage('static');
          document.addEventListener('click', function(event) {
            var urlHistory = "";
            // getNextPage();
            const elNextPage = document.querySelector('.pagination a:last-of-type');
            const elMainCollection = document.querySelector("div.collection");
            const elMainProductListFirst = document.querySelector('.product-list');
                     
                  if (event.target.matches('#loadmore')) {
                      var nextUrlPage = getNextPage();
                      console.log(nextUrlPage);
                      
                      loadmore.innerHTML = `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`;
                      loadmore.classList.remove("button-loadding-prodcuts");
                     
                      
                        fetch(nextUrlPage)
                        .then(response => {
                          if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                          }
                          
                          return response.text();
                        })
                        .then(html => {
                            const parser = new DOMParser();
                            const docNextPage =  parser.parseFromString(html, 'text/html');
                            const nextPageDataProduct = docNextPage.querySelectorAll('.product-card');
                          
                           
                            
                          
                            nextPageDataProduct.forEach((key) => {
                              key.style = "opacity: 1; transform: translateY(0px);"
                              elMainProductListFirst.append(key);
                              key.setAttribute("data-from-page",nextUrlPage);
                              
                            });
   
                            var parsedUrl = new URL(nextUrlPage);
                            var urlParams = new URLSearchParams(parsedUrl.search);
                            var pageNumber = urlParams.get('page');
                            var params = parsedUrl.searchParams;
                          
                             history.replaceState(null, null, parsedUrl.href); 
                            newNextPage = parseInt(pageNumber) + 1;
                            // Change 'page' 
                            params.set('page', newNextPage);

                              
                            var newNextUrlPage = parsedUrl.toString();
                            loadmore.setAttribute("data-next-link", newNextUrlPage);
                            const productsCount = loadmore.getAttribute("data-products-count");
                            const pageNumberInProducts = document.querySelector('page-number-in-products');
                             barLoadMore(pageNumber,productsCount);
                         
                        })
                        .catch(e => console.log('Error:', e));
                  }else if (event.target.matches(".product-card__image")) {
                        var mainDivProduct = event.target.parentElement.parentElement.parentElement;
                        var urlHistory = `${mainDivProduct.getAttribute("data-from-page")}#${mainDivProduct.id}`;
                        if(mainDivProduct.getAttribute("data-from-page") !== null){
                          // alert(urlHistory);
                          history.replaceState(null, null, urlHistory); 
                          // const acspe = event.target.parentElement.className;
                          //   var cspe = acspe.split(' ')[1]
                          //   const scrollPosition = window.scrollY;
                          //   localStorage.setItem("scrollPosition", cspe);
                        }else{
                            var urlHistory = `#${mainDivProduct.id}`;
                            var currentUrl = window.location.href;
                            var parsedUrl = new URL(currentUrl);
                            parsedUrl.hash = mainDivProduct.id;
                            history.replaceState(null, null, parsedUrl.toString()); 
                        }
                    }else if(event.target.matches("#loadbefore")){
                      var beforeUrlPage = getBeforePage('click');
                      
                   
                        if(beforeUrlPage != 1){
                          loadbefore.innerHTML = `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`;
                            
                             fetch(beforeUrlPage)
                              .then(response => {
                                if (!response.ok) {
                                  throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return response.text();
                              })
                              .then(html => {
                                  
                                  const parser = new DOMParser();
                                  const docNextPage =  parser.parseFromString(html, 'text/html');
                                  const nextPageDataProduct = docNextPage.querySelectorAll('.product-card');
                                  let elementsToInsert = [];

                                  nextPageDataProduct.forEach((key) => {
                                    key.style = "opacity: 1; transform: translateY(0px);"
                                    // elMainProductListFirst.insertBefore(key, elMainProductListFirst.childNodes[0]);
                                    key.setAttribute("data-from-page",beforeUrlPage);
                                    
                                      elementsToInsert.push(key);
                                  });



                                  
                                  // const newElementForScrolling = document.createElement('div');
                              
                                  // newElementForScrolling.style.display = 'none';
                                  // newElementForScrolling.id = 'none';
                                   if(loadbefore.getAttribute("data-before-pagenumber") <= 0){
                                      loadbefore.style.display = "none"
                                    }
                                  loadbefore.innerHTML = "▴ מוצרים קודמים "
                                  // Reverse the array of elements
                                  elementsToInsert.reverse();
                                // elementForScrollingBackAfterClick = ;
                              
                                  
                                  // Now insert each element at the beginning, which keeps them in reverse order
                                  elementsToInsert.forEach((element) => {
                                      elMainProductListFirst.insertBefore(element, elMainProductListFirst.childNodes[0]);
                                  });
                                
                                 // window.scrollTo(scrollPositionAfterClick);
                                                                scrollToId(elementsToInsert[0].id);
                            });
                            

                        }else{
                          
                        }
                     
                    
                  }
                  
    });

  if (history.scrollRestoration) {
    var browserAndDevice = detectBrowserAndDevice();
    if(browserAndDevice.isSafari){
      history.scrollRestoration = 'auto';
    }else{
      history.scrollRestoration = "manual";
    }
  }
  const scrollRestoration = history.scrollRestoration;
  if (scrollRestoration === "manual") {
    scrollToHash();
  }
   function detectBrowserAndDevice() {
      var userAgent = navigator.userAgent;
      var isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      var isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
  
      return {
          isSafari: isSafari,
          isMobile: isMobile
      };
  }
  function scrollToHash() {
    const hash = window.location.hash;
    if (hash) {
      const elementId = hash.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        // element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  
  function scrollToId(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
          element.scrollIntoView({
              block: 'start',     
              inline: 'nearest' 
          });
      } else {
          console.log('Element with ID ' + elementId + ' not found');
      }
  }

  // function scrollToClass(className) {
  //     const element = document.querySelector('.' + className);
  //     if (element) {
  //         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  // }
   // window.onload = function() {
   //              // const scrollPosition = localStorage.getItem("scrollPosition");
   //              // if (scrollPosition) {
   //              //     scrollToClass(scrollPosition)
   //              //     //window.scrollTo(0, scrollPosition);
   //              // }
   //              console.log("s");
   //          };